export interface RuntimeConfig {
  API_BASE_URL: string;
  RAWFILE_CONTAINER_NAME: string;
  FASTA_CONTAINER_NAME: string;
  OMICSFLOW_GENERAL_VERSION: string;
}

export let runtimeConfig: RuntimeConfig;

export async function loadRuntimeConfig() {
  const res = await fetch("/config.json", { cache: "no-store" });
  runtimeConfig = await res.json();
}
